module.exports = __webpack_public_path__ + "static/media/voucher.4be07d50.svg";